import React from 'react'
import { renderRoutes, RouteConfigComponentProps } from 'react-router-config'

const OfferingTag: React.FC<RouteConfigComponentProps> = ({ route }) => renderRoutes(route?.routes)

export default OfferingTag
